module.exports = __webpack_public_path__ + "img/foto-academia-4.ee2bfe3a.png";